/**
 * Asserts that a given value is of type `never`, which is the type left after all other cases have been removed, see
 * https://www.typescriptlang.org/docs/handbook/advanced-types.html.
 * @param x - The value that should never occur.
 */
export function assertNever(x: never): never {
  throw new Error('Unexpected object: ' + x);
}

/**
 * Returns the values in a given array that are not `null`. Note that without the `strictNullChecks` compiler option, the values in an array
 * `xs` that are not `null` can be obtained from the expression `xs.filter(x => x)`.
 * @param xs - The array to obtain values from that are not `null`.
 */
export function removeNulls<T>(xs: (T | null)[]): T[] {
  let ys: T[] = [];
  xs.forEach(x => {
    if (x) {
      ys.push(x);
    }
  });
  return ys;
}
